import React, { useEffect, useRef } from "react";
import aboutImage from "../assets/double-exposure-engineer-holding-blueprints-city-skyline-ai-generated.png";

const AboutSection = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current;
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight + 400;

      let progress = 1 - rect.top / windowHeight;
      progress = Math.max(0, Math.min(progress, 1));

      const radius = 1000 - progress * 1000; // <-- FIXED direction
      const translate = progress * 120; // <-- FIXED direction

      section.style.borderTopLeftRadius = `${radius}px`;
      section.style.borderTopRightRadius = `${radius}px`;

      if (contentRef.current) {
        contentRef.current.style.transform = `translateY(${translate}px)`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section ref={sectionRef} id="about" className="about">
      <div ref={contentRef} className="container about-inner">

        <div className="about-text">
          <h2 className="eyebrow">Where values</h2>
          <h2 className="about-heading">
            build <span>Homes</span>
          </h2>

          <p>
            At Dhanvanti Luxury Builders Pvt. Ltd., real estate is not just
            about land, concrete, and construction — it is about belief,
            responsibility, and long-term relationships.
          </p>

          <p>
            Every project we undertake is guided by a simple yet powerful
            philosophy — trust must be the foundation of everything we build.
          </p>

          <a href="#projects" className="btn-outline discover-btn">
            Discover More →
          </a>
        </div>

        <div className="about-image">
          <img
            src={aboutImage}
            alt="Architect"
            style={{
              transform: "scaleX(-1.2)",
              height: "500px",
              translate: "100px"
            }}
          />
        </div>

      </div>
    </section>
  );
};

export default AboutSection;
